module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.value) ? _c('span', {
    class: _vm.mainClass
  }, [_vm._v(_vm._s(_vm.value))]) : _vm._e(), _vm._v(" "), (!_vm.value && this.$slots.default && this.$slots.default[0].text.length) ? _c('span', {
    class: _vm.mainClass
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ff8850b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/Flag.vue
// module id = 2541
// module chunks = 1